import { render, staticRenderFns } from "./m_learn_chinese_language.vue?vue&type=template&id=40fce636&scoped=true"
import script from "./m_learn_chinese_language.vue?vue&type=script&lang=js"
export * from "./m_learn_chinese_language.vue?vue&type=script&lang=js"
import style0 from "./m_learn_chinese_language.vue?vue&type=style&index=0&id=40fce636&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fce636",
  null
  
)

export default component.exports